import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Este archivo busca el "enchufe" en el HTML y conecta tu App
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);